import { InterviewReviewTabs } from '~hooks/query/review/useGetInterview';

export const DUMMY_TABS: InterviewReviewTabs[] = [
  {
    id: 'process',
    content: '진행 방식',
  },
  {
    id: 'question',
    content: '질문 내용',
  },
  {
    id: 'attitude',
    content: '면접관 태도',
  },
  {
    id: 'atmosphere',
    content: '분위기',
  },
];
